import { cssJoin } from '@volvo-cars/css/utils';
import {
  AccordionDetails,
  AccordionSummary,
} from '@volvo-cars/react-accordion';
import { ReactElement } from 'react';

import styles from './Accordion.module.css';

export type AccordionBaseProps = {
  summaryAriaLabel: string;
  expanded: boolean;
  onChange: () => void;
  paddedContent?: boolean;
  background?: 'primary' | 'secondary';
  children: React.ReactNode;
};

type AccordionProps = AccordionBaseProps & {
  summary: ReactElement | string;
};

const Accordion: React.FC<AccordionProps> = ({
  summary,
  expanded,
  summaryAriaLabel,
  onChange,
  paddedContent = false,
  background = 'secondary',
  children,
}) => {
  const backgroundClass = `bg-${background}`;
  const summaryClassNames = cssJoin(
    styles.summary,
    expanded && styles.summaryOpen,
  );

  return (
    <AccordionDetails
      aria-label={summaryAriaLabel}
      className={backgroundClass}
      onToggle={onChange}
      open={expanded}
      style={{
        borderBottom: 'none',
      }}
    >
      <AccordionSummary iconAlignment="center" className={summaryClassNames}>
        {typeof summary === 'string' ? (
          <p className="font-medium">{summary}</p>
        ) : (
          summary
        )}
      </AccordionSummary>
      <div className={cssJoin(paddedContent && 'p-16 md:p-24')}>{children}</div>
    </AccordionDetails>
  );
};

export default Accordion;
